import $ from 'jquery';

// Features
import '../../features/vendor/videos/videos';
import '../../blocks/hero-front-page/hero-front-page';

import hide_on_scroll from './modules/hide-on-scroll';

$(function() {
  /*
   * Fix mobile menu modal for anchor links
   */
  // TODO: make this only apply to links that have a hash!
  // $('nav.is-responsive a').on('click', function(e) {
  //   const $container = $(e.currentTarget).closest('.wp-block-navigation__responsive-container');
  //   console.log($container);
  //   $container.removeClass('is-menu-open has-modal-open');
  //   $('html').removeClass('has-modal-open');
  // });

  // TODO: only apply hide on scroll on specific breakpoints
  const $toggle = $('.NavMobile .wp-block-navigation__responsive-container-open');
  hide_on_scroll($toggle);

  /*
   * Apply has-value attributes on form fields
   */

  const $inputs = $('.wpcf7-form-control');
  const inputWrapper = '.styled-input';

  // set data-focussed based on focus/blur state
  $inputs.on('focus blur', function(e) {
    $(this).closest(inputWrapper).attr('data-focused', e.type == 'focus');
  });

  $inputs.on('blur', function(e) {
    const $input = $(this);
    const hasValue = $input.val() != undefined && $input.val() != '';
    $input.closest(inputWrapper).attr('data-has-value', hasValue);
  });

  /*
   * Temporary alist show more
   */
  
  const $gigsTable = $('#alist-shows');
  console.log($gigsTable);
  const $shows = $gigsTable.find('.show:not(.header)');
  
  const increment = 10;
  var count = increment;
  const remaining = Math.max(0, $shows.length - count);

  $gigsTable.attr('data-remaining', remaining);


  if(remaining) {
    $shows.each((idx, el) => {
      if(idx >= count) {
        $(el).attr('data-display', 'none');
      }
    });
    const $button = $("<button class=\"alist-shows-showmore\"></button>").text('Show all');
    $button.insertAfter($gigsTable);
    $button.on('click', () => {
      $shows.attr('data-display', 'initial');
      $button.remove();
    });
  }
  
});
